export default __webpack_public_path__ + "static/media/activity_1.0ed6a50b.png";